<div class="quote-step9-quote-step4-5 animation-fadein" [ngClass]="rootClassName">
  <div class="logo-container stup-12" >
    <!-- Replace with your actual logo -->
    <img src="/assets/img/logo-image.svg" alt="Logo" class="logo" />
    <div class="text" style="max-width: 760px;">Su activación se ha realizado con éxito
      <p class="pt-2 font-weight-normal">
        En la próximas horas, recibirá un correo electrónico con los documentos de su compra. En caso de cualquier imprevisto no dude en ponerse en contacto con nosotros a 
        <br><a href="mailto:clientsupport@blueassist.biz">clientsupport&#64;blueassist.biz</a>
      </p>
      <p class="pt-2 font-weight-normal">Esperamos que su experiencia con Blue Assist sea satisfactoria y que disfrute de un viaje sin preocupaciones. Visite nuestra sección de asegurados para obtener información de la utilización de su asistencia ¡Gracias por confiar en nosotros!</p>
      <div class="button-box mb-3">
        <!-- <button class="continue-btn-steps" style="max-width: 440px;" (click)="goSegurados()">
          Sección de asegurados
        </button> -->
        <button class="continue-btn-steps" style="max-width: 440px;" (click)="goSegurados()">
          Sección de asegurados
        </button>
      </div>
      
    </div>
  </div>
  <!-- <img [attr.alt]="rectangle1269alt" [attr.src]="rectangle1269src" class="quote-step9-rectangle1269" />
  <span class="quote-step9-text"><span>volver</span></span>
  <div class="quote-step9-container">
    <span class="quote-step9-text02 Titular,Bold,18">
      <span>Su activación se ha realizado con éxito</span>
    </span>
    <span class="quote-step9-text04 DesK,P4,Regular,16">
      <span>
        En breve, recibirá un <b>correo electrónico y un mensaje de texto</b> (Whatsapp) con un enlace para descargar su
      certificado de asistencia de viaje. En caso de cualquier imprevisto no dude en ponerse en contacto con nosotros a <br>service&#64;blueassist.biz<br>
        Esperamos que su experiencia con Blue Assist sea satisfactoria y que disfrute de un viaje sin preocupaciones.
      Visite nuestra sección de <b>asegurados</b> para obtener información de la utilización de su asistencia ¡Gracias por
      confiar en nosotros!
      </span>
    </span>
    <button class="quote-step9-cotizar" (click)="goSegurados()">
      <span class="quote-step9-text06 Mob,H2,Bold12">
        <span>Sección de asegurados</span>
      </span>
    </button>
   
    <img
      [attr.alt]="gradient21alt"
      [attr.src]="gradient21src"
      class="quote-step9-gradient21"
    />
  </div> -->
</div>
